export interface MovieCategory {
  id: string;
  name: string;
  desc: string;
  icon: string;
  genre: string;
}

export const movieCategories: MovieCategory[] = [
  {
    id: "classic",
    name: "经典重温",
    desc: "历经时间考验的爱情佳作",
    icon: "ri-award-line",
    genre: "古典",
  },
  {
    id: "romcom",
    name: "浪漫喜剧",
    desc: "轻松治愈的都会爱情",
    icon: "ri-emotion-happy-line",
    genre: "浪漫喜剧",
  },
  {
    id: "realism",
    name: "现实题材",
    desc: "贴近生活的深情书写",
    icon: "ri-building-2-line",
    genre: "现实主义",
  },
  {
    id: "ancient",
    name: "古装爱情",
    desc: "东方美学里的执念与约定",
    icon: "ri-ancient-gate-line",
    genre: "古装爱情",
  },
  {
    id: "youth",
    name: "青春校园",
    desc: "回到那个阳光很慢的夏天",
    icon: "ri-plant-line",
    genre: "青春校园",
  },
  {
    id: "fantasy",
    name: "奇幻爱情",
    desc: "当爱情遇上时间与宇宙",
    icon: "ri-magic-line",
    genre: "奇幻爱情",
  },
];

export const regionOptions = [
  "全部",
  "中国大陆",
  "中国香港",
  "中国台湾",
  "日本",
  "韩国",
  "法国",
  "美国",
  "英国",
];

export const genreOptions = [
  "全部",
  "都市爱情",
  "浪漫喜剧",
  "文艺剧情",
  "青春校园",
  "古装爱情",
  "奇幻爱情",
  "科幻爱情",
  "现实主义",
  "治愈",
];

export const yearOptions = ["全部", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016"];